import React, { useEffect, useState } from 'react';
import http from '../../services/http-service';
import { toast } from 'react-toastify';
import { useHistory } from "react-router-dom";
// import Stack from '@mui/material/Stack';
import viewStatementIcon from '../../assets/view.png'
// import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import Moment from 'moment';
import CircularProgress from '@mui/material/CircularProgress';


function StatementSummery(props) {
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const [tableData, setTableData] = useState([]);



    useEffect(() => {
        fetchStatementData();
        // eslint-disable-next-line
    }, []);

    const goToStatementDetails = (id , date , start_balance , end_balance) => {
        history.push('/statement-details/'+id+'/'+props.userId+`?date=${date}&startBal=${start_balance}&endBal=${end_balance}`);
    }

    const handleClose = () => {
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(!open);
    };

    const fetchStatementData = (page) => {
        let params = {
            "user_id": props.userId
        }

        handleToggle()
        http('employee/payment/statement/history/', 'GET', '', params)
            .then(res => {
                if (res.status) {
                    setTableData(res.data.data);
                }
                else {
                    toast.error(res.message, {
                        toastId: "toastId1"
                    })
                }

                handleClose()
            },
                err => {
                    handleClose()
                });
    }

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}

            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {
                tableData.length > 0 ?
                    <div>
                        <div className='customTable statementTable'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>View</th>
                                        <th>Start Balance</th>
                                        <th>Money out</th>
                                        <th>Money in</th>
                                        <th>End Balance</th>
                                        <th>Period Start Date</th>
                                        {/* <th>Period End Date</th> */}
                                        <th>Report Creation Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        tableData.map((ele, index) => (
                                            <tr key={index}>
                                                <td><img style={{ cursor: 'pointer' }} onClick={()=>goToStatementDetails(ele.id , ele.reconciliation, ele.start_balance , ele.end_balance)} src={viewStatementIcon} alt='' /></td>
                                                <td>{ele.start_balance}</td>
                                                <td>{ele.money_out}</td>
                                                <td>{ele.money_in}</td>
                                                <td>{ele.end_balance}</td>
                                                <td>{Moment(ele.period_start_date).format('MM/DD/YYYY')}</td>
                                                <td>{Moment(ele.period_end_date).format('MM/DD/YYYY')}</td>
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                    :
                    <div className='recordNotFoundDiv'>
                        <h2>Records Not Found</h2>
                    </div>
            }
        </div>
    )

}
export default StatementSummery;